/* Check that the patient is at least 18 years of age. */
import moment from 'moment';
export default function(ssn) {
	if (ssn.length < 10) {
		return false;
	}

	var birthDate = ssn.slice(0, 10);
	var now = moment();
	var birthDateMoment = moment(birthDate);
	var patientAgeInYears = now.diff(birthDateMoment, 'years');

	if (patientAgeInYears > 17) {
		return true;
	}
	return false;
}
